module.exports = __webpack_public_path__ + "img/u4321.a9e09632.png";